export const getColumnsExcel = {
    0: 'reference',
    1: 'description',
    2: 'brand',
    3: 'model',
    4: 'number',
    5: 'color',
    6: 'count',
    7: 'quality',
    8: 'category',
    9: 'lastUpdated',
    10: 'location',
    11: 'pc',
    12: 'pvp',
    13: 'pvm',
    14: 'obs'
}

export const formatColumnExcel = index => {
    const valueDefault = value => value
    const valueNumber = value => value 
        ? Number(value.toString().replaceAll(",", ".")) 
        : value

    const map = {
        6: valueNumber,
        // 8: value => categoriesMap[value],
        11: valueNumber,
        12: valueNumber,
        13: valueNumber
    }

    return map[index] || valueDefault
}